export default {
  captableCompany: {},
  captableInfo: {},
};
